<template>
  <div class="PartnerDetails">
    <component
      v-if="!!unverifiedClientListFDataTableMetaData"
      :ref="unverifiedClientListFDataTableMetaData.myRefName"
      :is="unverifiedClientListFDataTableMetaData.componentName"
      :value="selectModel(partnerUnverifiedClientList, undefined)"
      v-bind="unverifiedClientListFDataTableMetaData.props"
    ></component>
  </div>
</template>

<script lang="ts">
import FForm from "@/components/form/FForm.vue";
import FDataTable from "@/components/table/FDataTable.vue";
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
// import store, * as Store from '@/../src-gen/store';
import * as Data from "@/../src-gen/data";
// import * as ServerData from '@/../src-gen/server-data';
import * as Action from "@/../src-gen/action";
import ModelVue from "@/components/ModelVue";
import UnverifiedClientListFDataTableMDP from "./UnverifiedClientListFDataTableMDP";

@Component({
  components: {
    FForm,
    FDataTable,
  },
})
export default class UnverifiedClientList extends ModelVue {
//   partnerId = this.$route.params.partnerId;

  partnerUnverifiedClientList: any = [];

  public mounted() {
    this.getUnverifiedFileList();
  }


    get partnerId() {
    return localStorage.getItem("partnerId") || "";
    }
  getUnverifiedFileList() {
    Action.Partner.GetUnverifiedFileList.execute1(this.partnerId, (output) => {
      this.partnerUnverifiedClientList = output;
    });
  }


  // Meta data
  get unverifiedClientListFDataTableMetaData() {
    return new UnverifiedClientListFDataTableMDP({
      parent: this,
    }).getMetaData();
  }
}
</script>

<style></style>
